import { Heading } from '../Heading/Heading'
import { Label } from './Label'

export const LabelPresentation = () => (
  <div>
    <Heading size={4}>Label:</Heading>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Required Label *** */}

      <Label isRequired>This is a required label text</Label>

      {/* *** Optional Label *** */}

      <Label>This is an optional label text</Label>
    </div>
  </div>
)
